/* AvailComponent.js */

"use strict";
const Renderer = require("./AvailRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class AvailComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "avail",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            dow: [2, 3, 4, 5, 6],
            after: {hour: 8, minute: 0},
            before: {hour: 17, minute: 0},
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = AvailComponent;
